export function chatDateLabel(timestamp: number | undefined, now = new Date()): string {
 if(timestamp === undefined || !Number.isFinite(timestamp)) return '';
 const date=new Date(timestamp*1000);
 if(Number.isNaN(date.getTime())) return '';
 // Calendar-day differences remain correct across daylight-saving changes.
 const day=(d:Date)=>Date.UTC(d.getFullYear(),d.getMonth(),d.getDate());
 const age=(day(now)-day(date))/86400000;
 if(age===0)return 'Hoy';
 if(age===1)return 'Ayer';
 const label=new Intl.DateTimeFormat('es-ES',age>1&&age<7
  ? {weekday:'long'} : {day:'numeric',month:'long',year:'numeric'}).format(date);
 return label.charAt(0).toLocaleUpperCase('es-ES')+label.slice(1);
}
